import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {fiatAccounts$} from '@/fiat-account/fiat-accounts';
import type {FiatAccount} from '@/types';
import {fiatDepositSuccessMsg$} from '@/raw/fiat-account';

export interface UFiatAccounts {
  type: 'fiat-accounts';
  data: {
    accounts: FiatAccount[];
  };
}

export interface UFiatDepositSuccessMsg {
  type: 'fiat-deposit-success';
  data: any;
}

export function subscribeFiatAccount() {
  fiatAccounts$
    .pipe(map<FiatAccount[], UFiatAccounts>((accounts) => ({type: 'fiat-accounts', data: {accounts: accounts}})))
    .subscribe((msg: UFiatAccounts) => toUiMsg$.next(msg));
  subscribeFiatDepositPush();
}

export function subscribeFiatDepositPush() {
  fiatDepositSuccessMsg$
    .pipe(map((msg) => ({type: 'fiat-deposit-success', data: msg})))
    .subscribe((msg: UFiatDepositSuccessMsg) => toUiMsg$.next(msg))
}
